module.exports = __webpack_public_path__ + "015a6602bbbc7f35478ef1d8eb78469b.jpg";